import { render, staticRenderFns } from "./teaching-picture.vue?vue&type=template&id=6286cf9e&scoped=true"
import script from "./teaching-picture.vue?vue&type=script&lang=js"
export * from "./teaching-picture.vue?vue&type=script&lang=js"
import style0 from "./teaching-picture.vue?vue&type=style&index=0&id=6286cf9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6286cf9e",
  null
  
)

export default component.exports